import { axios } from '@/lib/axios';
import { useQuery,useMutation } from 'react-query';

import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';

import { ProductResponse } from '../types/indes';
import { showNotification } from '@/utils/notificationUtils';


export type DTO1 = {
    page: number;
    perPage: number;
    search?: string;
    filter?: any;
};

export const getUserList = (
    {  page, perPage, search, filter }: DTO1 = {
      page: 1,
      perPage: 200,
    }
  ): Promise<ProductResponse> => {
    return axios.post(`/account/product-list`,  {
      page,
      perPage,
      search,
      filter
     });
  };


type UseOptions = {
  config?: MutationConfig<typeof getUserList>;
};

export const useGetProductList= ({ config }: UseOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getUserList,
  });
};






export type DTO11 = {
  page: number;
  perPage: number;
  search?: string;
  filter?: any;
};

export const getClaimList = (
  {  page, perPage, search, filter }: DTO11 = {
    page: 1,
    perPage: 20,
  }
): Promise<ProductResponse> => {
  return axios.post(`/account/claim-list`,  {
    page,
    perPage,
    search,
    filter
   });
};


type UseOptionss = {
config?: MutationConfig<typeof getClaimList>;
};

export const useGetClaimList= ({ config }: UseOptions = {}) => {
return useMutation({
  ...config,
  mutationFn: getClaimList,
});
};




export type DTO131 = {
  page: number;
  perPage: number;
  search?: string;
  filter?: any;
};

export const getUserLists = (
  {  page, perPage, search, filter }: DTO131 = {
    page: 1,
    perPage: 20,
  }
): Promise<ProductResponse> => {
  return axios.post(`/account/user-list`,  {
    page,
    perPage,
    search,
    filter
   });
};


type UseOptionsss = {
config?: MutationConfig<typeof getUserLists>;
};

export const useGetUsersListForClaim= ({ config }: UseOptionsss = {}) => {
return useMutation({
  ...config,
  mutationFn: getUserLists,
});
};

